export interface PostalCodeWebEntity {
    id: string;
    postalCode: string;
    city: string;
  }
  